<div class="container-fluid" xmlns="http://www.w3.org/1999/html">

  <app-page-title [title]="'Proofreader API'" [icon]="'bi-spellcheck'">
    <a class="btn btn-light"
       href="https://github.com/explainers-by-googlers/proofreader-api"
       target="_blank"><i
      class="bi bi-file-text"></i> <span class="ms-2">Explainer</span></a>
    <a class="btn btn-light disabled"
       href="https://github.com/explainers-by-googlers/proofreader-api" target="_blank"><i
      class="bi bi-body-text"></i> <span class="ms-2">Specifications</span></a>
  </app-page-title>


  <div class="row mb-3">
    <div class="col-12">

      <app-page-accordion
        [requirementsStatus]="this.apiFlag.status"
        (checkRequirementsEvent)="checkRequirements()"
        [requirements]="[this.getRequirement()]"
      >
        <div debugInformation>
          No debug information available.
        </div>
      </app-page-accordion>
    </div>
  </div>

  <h2 class="display-6 mt-5"><i class="bi bi-play"></i> Playground</h2>
  <hr>

  <app-output
    [status]="this.status"
    [error]="this.error"
    [downloadProgress]="this.loaded"
    [outputCollapsed]="outputCollapsed"
    [statisticsCollapsed]="statisticsCollapsed"
    [output]="this.output"
    (abortExecution)="abortTriggered()"
    (abortExecutionFromCreate)="abortFromCreateTriggered()"
  >

  </app-output>

  <div class="row mt-5">
    <div class="col-12 col-md-6">
<!--      <h3 class="mt-3">Input:</h3>-->
<!--      <textarea class="form-control" rows="8" [formControl]="inputFormControl"></textarea>-->

<!--      <h3 class="mt-3">Context:</h3>-->
<!--      <textarea class="form-control" rows="3" [formControl]="contextFormControl"></textarea>-->
    </div>
    <div class="col-12 col-md-6">
      <h4 class="mt-4">Options</h4>

    </div>
    <div class="d-grid mt-3">
      <button class="btn btn-primary btn-lg" (click)="proofread()">Proofread</button>
    </div>
  </div>

  <h2 class="display-6 mt-5"><i class="bi bi-code-square"></i> Runnable code examples</h2>
  <hr>

  <div class="row">
    <div class="col-12 col-md-6">
      <div class="card mt-3">
        <div class="card-header">
          <h4>Availability</h4>
        </div>
        <div class="card-body">
          <h5>Code</h5>
          <code-editor [code]="checkAvailabilityCode" [readonly]="true" [height]="'100px'"></code-editor>

          <h5 class="mt-3">Result</h5>
          <span class="code"
                [class.code-warning]="availabilityStatus === AvailabilityStatusEnum.AfterDownload || availabilityStatus === AvailabilityStatusEnum.Downloadable"
                [class.code-danger]="availabilityStatus === AvailabilityStatusEnum.No || availabilityStatus === AvailabilityStatusEnum.Unavailable"
                [class.code-success]="availabilityStatus === AvailabilityStatusEnum.Readily || availabilityStatus === AvailabilityStatusEnum.Available"
                [class.code-dark]="availabilityStatus === AvailabilityStatusEnum.Unknown"
          >{{ availabilityStatus }}</span>

          @if (availabilityError) {
            <div class="alert alert-danger m-0 mt-2 mb-2">{{ availabilityError }}</div>
          }

          <div class="row mt-5">
            <div class="col-12 d-grid">
              <button class="btn btn-outline-primary d-block" (click)="checkAvailability()">Check availability</button>
            </div>
          </div>

        </div>
      </div>
    </div>
    <div class="col-12 col-md-6">
      <div class="card mt-3">
        <div class="card-header d-flex">
          <h4 class="flex-grow-1 m-0">Execute</h4>
        </div>
        <div class="card-body">
          <h5>Code</h5>
          <code-editor [code]="proofreadCode" [readonly]="true" [height]="'250px'"></code-editor>

          <div class="mt-3 mb-3 d-flex">
          </div>
          @if (status === TaskStatus.Error) {
            <div class="alert alert-danger m-0 mb-2">{{ outputStatusMessage }}</div>
          }

          <div class="row mt-2">
            <div class="col-12 d-grid">
              <button class="btn btn-primary d-block" (click)="proofread()">Proofread</button>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>



